import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { CLEAR_ABORT_CONTROLLER } from '../actionConstants';

function useAbortController() {
  const location = useLocation();
  const dispatch = useDispatch();

  const requestControllers = useSelector(
    (state) => state.common.requestControllers,
  );

  useEffect(() => {
    if (requestControllers?.length > 0) {
      requestControllers.forEach((controller) => controller?.abort());
      dispatch({ type: CLEAR_ABORT_CONTROLLER });
    }
  }, [location]);
}

export default useAbortController;
